export default "__VITE_ASSET__DaE37sl2__"